import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { FaqQuestions } from "./faq-dialog.type";
import { MatTableDataSource } from "@angular/material/table";

@Component({
	selector: "app-faq-dialog",
	templateUrl: "./faq-dialog.component.html",
	styleUrls: ["./faq-dialog.component.scss"],
})
export class FaqDialogComponent implements OnInit {
	currentLang: string;
	panelOpenState = false;
	faqQuestions: FaqQuestions = {
		general: [],
		renewal: [],
		claims: [],
		roadtax: [],
	};

	selectedInsurer: string = "";
	insurerList = [
		{ id: "zurich", name: "Zurich / Zurich Takaful" }
	];
	filteredInsurerList = this.insurerList; // Assign default value

	// Zurich Table
	zurichFAQTableColumns: string[] = [ "period", "refundPercentage" ];
	zurichFAQTableData;

	constructor(
		private translate: TranslateService,
		private sanitizer: DomSanitizer,
	) {}

	ngOnInit(): void {
		const faqKeys = Object.keys(this.faqQuestions);

		faqKeys.forEach((key) => {
			this.translate.get(`faq.${key}`).subscribe((translatedText) => {
				this.faqQuestions[key] = translatedText;
			});
		});

		this.loadZurichFAQTableData();
	}

	switch(lang: string) {
		this.translate.use(lang);
	}

	getSanitizedAnswer(html: string): SafeHtml {
		const urlRegex = /https?:\/\/[^\s]+/g;
		const replacedHtml = html.replace(
			urlRegex,
			(url) =>
				`<a href="${url}" target="_blank" style="color: #0091FF">${url}</a>`,
		);
		return this.sanitizer.bypassSecurityTrustHtml(replacedHtml);
	}

	onSearch(value: string) {
		this.filteredInsurerList = this.insurerList.filter(x => x.name.toLocaleLowerCase().includes(value));
	}

	private loadZurichFAQTableData() {
		this.translate.get("faq.zurichFAQTableData").subscribe((translatedText) => {
			this.zurichFAQTableData = new MatTableDataSource<IZurichFAQ>(translatedText);
		});
	}
}

export interface IZurichFAQ {
  period: string;
  refundPercentage: string;
}